<!--
 * @description:
 * @author: 06455
 * @date: 2024/3/27 16:40
-->
<template>
  <a-modal v-model="modal" title="自动计算" width="400px" :maskClosable="false" :closable="false">
    <a-alert banner class="alertClass">
      <template #message>
        <div>确定要触发自动计算吗?</div>
        <div class="redText">请确认其他调度人员已关闭新增页面</div>
      </template>
    </a-alert>
    <a-radio-group v-model="supplierIs" @change="changeSupplier">
      <a-radio :value="0">全部供应商</a-radio>
      <a-radio :value="1">选择供应商</a-radio>
    </a-radio-group>
    <ls-select
      v-if="supplierIs"
      class="selectClass"
      v-model="factoryCodeList"
      :showSearch="true"
      placeholder="请选择"
      :options="selectSupplierList"
      :filter-option="filterOption"
      allowClear
      mode="multiple"
      @search="handleSupplierSearch"
    />
    <template #footer>
      <a-button @click="cancelOk" :loading="loading">取消</a-button>
      <a-button type="primary" :loading="loading" @click="submitOk">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import { apiGetsupplier, apiReceiptPlanAutoCalculate } from '@/services/module/receiving-plan'
export default {
  name: 'AutoComputedModal',
  data() {
    return {
      modal: false,
      supplierIs: 0,
      selectSupplierList: [],
      factoryCodeList: [],
      loading: false
    }
  },
  methods: {
    show() {
      this.modal = true
      this.factoryCodeList = []
    },
    changeSupplier() {
      this.factoryCodeList = []
    },
    submitOk() {
      const _this = this
      if(this.supplierIs && this.factoryCodeList.length === 0) {
        return this.$message.warning('请选择供应商')
      }
      this.$emit('click', true)
      this.loading = true
      apiReceiptPlanAutoCalculate(this.factoryCodeList).then((res) => {
        const { data, msg } = res
        if (data) {
          _this.$message.success(msg)
          _this.modal = false
        }
      }).finally(() => {
        _this.loading = false
        _this.$emit('click', false)
      })
    },
    cancelOk() {
      this.modal = false
    },
    // 手动输入
    filterOption (input, option) {
      return option.componentOptions.children[0].text.toLowerCase().trim().indexOf(input.toLowerCase().trim()) >= 0
    },
    handleSupplierSearch (val) {
      apiGetsupplier({ supplierQueryStr: val, page: 1, pageSize: 50 }).then(res => {
        this.selectSupplierList = res?.data?.map(item => {
          return {
            value: item.companyCode,
            label: item.companyName
          }
        }) || []
      })
    }
  }
}
</script>

<style scoped lang='less'>
.alertClass{
  margin-bottom:8px;
}
.redText{
  color:red
}
.selectClass{
  margin-top:8px;
  width:100%
}
</style>
